import { render, staticRenderFns } from "./SelectDict.vue?vue&type=template&id=f7b0c2fc&scoped=true"
import script from "./SelectDict.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectDict.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b0c2fc",
  null
  
)

export default component.exports